module.exports = __webpack_public_path__ + "img/shield.ac52b1a2.svg";